/**
 * Case type visual picker: if the selected option is unavailable for the
 * current device (radio has .disabled), switch to the first available case type.
 */
function fixCaseTypePickerSelection(variantSelects) {
  if (!variantSelects?.querySelector) return;
  const fieldset = variantSelects.querySelector('.product-form__input--case-card');
  if (!fieldset) return;

  const checked = fieldset.querySelector('input[type="radio"]:checked');
  if (checked && checked.classList.contains('disabled')) {
    const firstOk = fieldset.querySelector('input[type="radio"]:not(.disabled)');
    if (firstOk) {
      firstOk.checked = true;
      setTimeout(() => {
        firstOk.dispatchEvent(new Event('change', { bubbles: true }));
      }, 0);
    }
  }
}

window.fixCaseTypePickerSelection = fixCaseTypePickerSelection;

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('variant-selects').forEach((vs) => fixCaseTypePickerSelection(vs));
});

document.addEventListener('product-info:loaded', (event) => {
  const vs = event.target?.querySelector?.('variant-selects');
  fixCaseTypePickerSelection(vs);
});
